(function () {
  if (window.ssAlbumVariantCopyLoaded) return;
  window.ssAlbumVariantCopyLoaded = true;

  function update(sourcePicker) {
    var pickers = Array.from(document.querySelectorAll('main variant-radios, main variant-selects'));
    var picker = sourcePicker || pickers.find(function (el) { return el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden'; }) || pickers[0];
    if (!picker) return;
    var variant = picker.currentVariant;
    if (!variant) {
      var input = document.querySelector('main form[data-type="add-to-cart-form"] input[name="id"]');
      var data = picker.querySelector('[type="application/json"]');
      if (input && data) {
        try { variant = JSON.parse(data.textContent).find(function (v) { return String(v.id) === input.value; }); } catch (e) { return; }
      }
    }
    var pageOption = variant && variant.options.find(function (option) { return /^(40|80)(?:\s*pages)?$/i.test(String(option).trim()); });
    var pages = pageOption && String(pageOption).match(/40|80/)[0];
    document.querySelectorAll('[data-album-copy]').forEach(function (el) {
      var copy = pages && el.getAttribute('data-copy-' + pages);
      var html = copy || el.getAttribute('data-copy-default');
      if (el.innerHTML !== html) el.innerHTML = html;
    });
  }

  document.addEventListener('change', function (event) {
    var picker = event.target.closest('main variant-radios, main variant-selects');
    if (picker || event.target.closest('main form[data-type="add-to-cart-form"]')) requestAnimationFrame(function () { update(picker); });
  });
  document.addEventListener('itemChangedData', function (event) {
    var picker = event.target.closest('main variant-selects');
    if (picker) requestAnimationFrame(function () { update(picker); });
  }, true);
  document.addEventListener('shopify:section:load', function () { update(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { update(); });
  else update();
})();
